module.exports = __webpack_public_path__ + "static/margarita-0bb7a5a982e31e82e3da1d619bfd4823.png";